import React, { PropsWithChildren } from 'react';

import { Box, Icon, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import { HomeExternalAccountsQuery } from './graphql/query.homeExternalAccounts.generated';

import { trackClick } from '../../features/track';
import { urlBuilder } from '../../Shared/urlBuilder';

const OptionLink: React.FC<PropsWithChildren<{ href: string }>> = ({ href, children }) => {
  return (
    <SambaAutoLink to={href} onClick={() => trackClick({ name: 'ElementClicked' })}>
      <Box css={{ marginLeft: 'space.600', display: 'flex', alignItems: 'bottom' }}>
        <Icon name="Transfer" size="xsmall" css={{ marginRight: 'space.100' }} />
        {children}
      </Box>
    </SambaAutoLink>
  );
};

type Props = { account: HomeExternalAccountsQuery['externalAccounts'][number] };

export const ExternalAccountTransactionOptionLink: React.FC<Props> = ({ account }) => {
  const { legacyId: id, transactionOption } = account;
  const rolloverOption = transactionOption?.__typename === 'RolloverOption' ? transactionOption : null;
  const transferOption = transactionOption?.__typename === 'ExternalTransferOption' ? transactionOption : null;

  if (!rolloverOption && !transferOption) {
    return null;
  }

  return (
    <>
      {transferOption && (
        <OptionLink href={urlBuilder.appExternalTaxableAccountTransferFlowsNew.absolute({ external_account_id: id })}>
          <Text variant="text50" color="text.link">
            Eligible for automated transfer
          </Text>
        </OptionLink>
      )}
      {rolloverOption && (
        <OptionLink href={urlBuilder.appExternalAccountsRolloverStart.absolute({ externalAccountId: id })}>
          <Text variant="text50" color="text.link">
            {rolloverOption.isPartiallyAcatsable ? 'Start rollover' : 'Eligible for automated transfer'}
          </Text>
        </OptionLink>
      )}
    </>
  );
};
